import React, { useState } from 'react';
import { X, QrCode } from 'lucide-react';
import { assetsAPI } from '../../utils/api';
import toast from 'react-hot-toast';

export default function QRScannerModal({ onClose, onResult }) {
  const [manualCode, setManualCode] = useState('');
  const [loading, setLoading] = useState(false);

  const handleManual = async () => {
    if (!manualCode.trim()) return;
    setLoading(true);
    try {
      const res = await assetsAPI.getByQR(manualCode.trim());
      onResult(res.data);
    } catch {
      toast.error('Asset not found with this QR code');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal modal-sm" style={{ margin: 20 }}>
        <div className="modal-header">
          <div>
            <div className="modal-title">Scan Asset QR Code</div>
            <div style={{ fontSize:13, color:'var(--text-muted)', marginTop:2 }}>Use your camera or enter code manually</div>
          </div>
          <button className="btn-icon" onClick={onClose}><X size={16} /></button>
        </div>
        <div className="modal-body" style={{ display:'flex', flexDirection:'column', gap:16 }}>
          <div style={{
            height:200, background:'#0F172A', borderRadius:'var(--r-lg)',
            display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', gap:12,
            position: 'relative', overflow: 'hidden'
          }}>
            <QrCode size={56} color="rgba(255,255,255,0.2)" className="animate-pulse" />
            <div style={{ color:'rgba(255,255,255,0.5)', fontSize:13 }}>Camera scanning...</div>
            
            {/* Animated Scan Line */}
            <div style={{ 
              position: 'absolute', top: 0, left: 0, right: 0, height: 2, 
              background: 'var(--accent)', opacity: 0.5,
              animation: 'scanLine 2s linear infinite' 
            }} />
          </div>
          
          <div style={{ textAlign:'center', color:'var(--text-muted)', fontSize:12, fontWeight: 600 }}>— OR ENTER MANUALLY —</div>
          
          <div style={{ display:'flex', gap:8 }}>
            <input className="form-input" value={manualCode} onChange={e=>setManualCode(e.target.value)}
              placeholder="Enter QR code value..." style={{ fontFamily:'var(--font-mono)', fontSize:13 }}
              onKeyDown={e=>e.key==='Enter'&&handleManual()} />
            <button className="btn btn-primary" onClick={handleManual} disabled={loading}>
              {loading ? '...' : 'Find'}
            </button>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes scanLine {
          0% { top: 0; }
          100% { top: 100%; }
        }
      `}</style>
    </div>
  );
}
